<template>
  <section class="mb-5 mt-5">
    <b-row>
      <b-col sm="12" class="small">
        <p class="mb-0 ml-3">
          ©&nbsp;{{ new Date().getFullYear() }}&nbsp;Bluetooth SIG, Inc. All
          rights reserved.
        </p>
        <b-nav>
          <b-nav-item href="https://www.bluetooth.com/privacy"
            >Privacy</b-nav-item
          >
          <b-nav-item href="https://www.bluetooth.com/terms-of-use"
            >Terms Of Use</b-nav-item
          >
          <b-nav-item href="https://www.bluetooth.com/user-code-of-conduct"
            >Code Of Conduct</b-nav-item
          >
          <b-nav-item href="https://www.bluetooth.com/copyright-policy"
            >Copyright Policy</b-nav-item
          >
          <b-nav-item href="https://www.bluetooth.com/sig-policies"
            >SIG Policies and Rules</b-nav-item
          >
        </b-nav>
      </b-col>
    </b-row>
  </section>
</template>
<script>
export default {
  name: "Footer"
};
</script>
